var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu"},[(true || _vm.$route.name === 'index___' + _vm.$i18n.locale)?_c('button',{staticClass:"menu__trigger",attrs:{"on":"tap:sidebar.open"}},[_vm._v("\n     \n  ")]):_c('button',{staticClass:"menu__close",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("\n     \n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }